import { render, staticRenderFns } from "./MultiselectTag.vue?vue&type=template&id=189a2320&"
import script from "./MultiselectTag.vue?vue&type=script&lang=js&"
export * from "./MultiselectTag.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports